import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ContentState } from 'draft-js'
import IconButton from 'material-ui/IconButton'
import BgColorIcon from 'material-ui/svg-icons/editor/format-color-fill'
import { Map } from 'immutable'
import { CirclePicker as ColorPicker } from 'react-color'
import SubEditor from './SubEditor'
import { replaceBlockText } from './modifiers'
import './styles.css'

class SubBlock extends Component {
  static propTypes = {
    // note: these are passed in via the editor's `blockRendererFn`
    blockProps: PropTypes.shape({
      onStartEdit: PropTypes.func.isRequired,
      onFinishEdit: PropTypes.func.isRequired,
      updateBackgroundColor: PropTypes.func.isRequired,
    }).isRequired,
    contentState: PropTypes.instanceOf(ContentState).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      isEditMode: false,
      text: '',
      isPickerOpen: false,
      anchorEl: null,
      liveEdits: Map(),
    }
  }

  onValueChange = ev => this.setState({ text: ev.target.value })

  getEntityData(dataKey) {
    return this.props.contentState
      .getEntity(this.props.block.getEntityAt(0))
      .getData()[dataKey]
  }

  handleClickText = () => {
    if (this.state.isEditMode) {
      return
    }

    this.setState({
      isEditMode: true,
      text: this.props.block.getText(),
    }, this.startEdit)
  }

  saveEdits = () => {
    const newContentState = replaceBlockText(
      this.state.text,
      this.props.contentState,
      this.props.block,
    )

    this.setState({
      isEditMode: false,
      text: null,
    }, () => {
      this.finishEdit(newContentState)
    })
  }

  discardEdits = () => {
    this.setState({
      isEditMode: false,
      text: null,
    }, () => {
      this.finishEdit(this.props.contentState, true)
    })
  }

  startEdit = () => {
    this.props.blockProps.onStartEdit()
    const nextLiveEdits = this.state.liveEdits.set(this.props.block.getKey(), true)
    this.setState({ liveEdits: nextLiveEdits })
  }

  finishEdit = (newContentState, overrideFocus = false) => {
    const nextLiveEdits = this.state.liveEdits.remove(this.props.block.getKey())

    this.setState({ liveEdits: nextLiveEdits }, () => {
      const shouldRestoreFocus = overrideFocus || this.state.liveEdits.count() < 1

      this.props.blockProps.onFinishEdit(
        newContentState,
        shouldRestoreFocus,
      )
    })
  }

  openPicker = (ev) => {
    ev.preventDefault()

    this.startEdit()

    this.setState({
      isPickerOpen: true,
      anchorEl: ev.currentTarget,
    })
  }

  closePicker = () => {
    this.setState({
      isPickerOpen: false,
    }, this.finishEdit.bind(this, this.props.contentState))
  }

  updateBackgroundColor = (colorObj) => {
    const { hex } = colorObj
    const entityKey = this.props.block.getEntityAt(0)
    this.props.blockProps.updateBackgroundColor(entityKey, hex)
  }

  render() {
    let content = null

    if (this.state.isEditMode) {
      content = this.state.text
    } else {
      content = this.props.block.getText()
    }

    let className = 'ColorBlock-tex'
    if (this.state.isEditMode) {
      className += ' ColorBlock-activeTeX'
    }

    const styles = this.getEntityData('styles')

    return (
      <div className={className}>
        <div
          ref="container"
          className="ColorBlock-header"
          style={styles}
        >
          <span onClick={this.handleClickText}>{content}</span>
          <IconButton
            tooltip="Change background color"
            tooltipPosition="bottom-left"
            onClick={this.openPicker}
            style={{ padding: 0, float: 'right' }}
            iconStyle={{}}
          >
            <BgColorIcon color="black" />
          </IconButton>
        </div>
        {!this.state.isPickerOpen ? null :
        <ColorPicker
          color={styles.backgroundColor}
          onChange={this.updateBackgroundColor}
          onChangeComplete={this.closePicker}
        />
        }
        {!this.state.isEditMode ? null :
        <SubEditor
          onValueChange={this.onValueChange}
          text={this.state.text}
          save={this.saveEdits}
          discard={this.discardEdits}
        />
        }
      </div>
    )
  }
}

export default SubBlock



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/ColorBlock/SubBlock.js